import React, { useState, useEffect } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIDataTable from "mui-datatables";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import NewOrder from "./Components/NewOrder";
import Order from "./Components/Order";
import useSave from "../../Hooks/useSave";
import PrintIcon from "@mui/icons-material/Print";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import useProtectView from "../../Hooks/useProtectView";
import NewOrderCustomer from "./Components/NewOrderCustomer";
import PreviewIcon from "@mui/icons-material/Preview";
import Popover from "../../components/Popover/Popover";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CompleteOrder from "./Components/CompleteOrder";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AddCustomer from "./Components/AddCustomer";
import NoteIcon from "@mui/icons-material/Note";
export default function Orders() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchGraphql, DialogSave } = useSave();
  const canView = useProtectView();
  const [order, setOrder] = useState({});
  const [products, setProducts] = useState([]);
  const [messages, setMessages] = useState([]);

  const [data, setData] = useState([]);

  //create date
  const today1 = new Date();
  const tomorow1 = new Date(today1.getTime() + 24 * 60 * 60 * 1000);
  const tomorowNoTime = new Date(new Date(tomorow1).setHours(0, 0, 0, 0));
  const tomorowEndofDay = new Date(
    new Date(tomorow1).setHours(23, 59, 59, 999),
  );

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isBig = useMediaQuery(theme.breakpoints.up("sm"));

  const [fromDate, setFromDate] = useState(tomorowNoTime);
  const [toDate, setToDate] = useState(tomorowEndofDay);

  useEffect(() => {
    fetchGraphql({
      query: `query Orders($options: optionsInput) {
        orders(options: $options) {
          paymentStatus
          packDate
          orderedVia
          orderStatus
          orderId
          orderDate
          lastEditedBy
          packedBy
          deliveryDate
          customerName
          customerId
          createdBy
          orderNote
        }
      }`,
      variables: {
        options: { deliveryFromDate: fromDate, deliveryToDate: toDate },
      },
    }).then((result) => setData(result.data.orders));

    fetchGraphql({
      query: `query Messages($startDate: String, $endDate: String) {
        messages(startDate: $startDate, endDate: $endDate) {
          message
        }
      }`,
      variables: { startDate: new Date(), endDate: new Date() },
    }).then((result) => {
      setMessages(result.data.messages);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const [hidePopover, setHidePopover] = useState(false);

  const filterPopoverExit = () => {
    setHidePopover(false);
    // this.setActiveIcon();
  };

  const groupBy = (items, key) => {
    return items?.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {},
    );
  };

  const groupedProducts = groupBy(
    products?.filter((item) => item.combinedId > 0),
    "combinedId",
  );

  const columns = [
    {
      name: "orderId",
      label: "Order Id",
    },
    {
      name: "orderDate",
      label: "Order Date",
      options: {
        display: isBig,
      },
    },
    {
      name: "packDate",
      label: "Pack Date",
      options: {
        display: isBig,
      },
    },
    {
      name: "deliveryDate",
      label: "Delivery Date",
      options: {
        filter: true,
        display: "true",
        filterType: "custom",
        filterOptions: {
          logic: (location, filters, row) => {
            return false;
          },
          display: (filterList, onChange, index, column) => {
            return (
              <Box>
                <Typography sx={{ marginBottom: "10px" }}>
                  Delivery Date
                </Typography>

                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="From Date"
                    sx={{ marginBottom: "10px" }}
                    openTo="day"
                    views={["year", "month", "day"]}
                    shouldDisableDate={(date) => {
                      const today = new Date();
                      const todayDate = new Date(date);

                      // if (date < today.setDate(today.getDate() - 1))
                      //   return true;

                      if (date > toDate) return true;

                      // if (todayDate.getDay() === 6) return true;
                    }}
                    value={fromDate || tomorow1}
                    onChange={(newValue) => {
                      setFromDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <Box sx={{ marginTop: "10px" }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="To Date"
                      openTo="day"
                      views={["year", "month", "day"]}
                      // shouldDisableDate={(date) => {
                      //   const today = new Date();
                      //   const todayDate = new Date(date);

                      //   if (date < today.setDate(today.getDate() - 1))
                      //     return true;

                      //   if (todayDate.getDay() === 6) return true;
                      // }}
                      value={toDate || tomorow1}
                      onChange={(newValue) => {
                        setToDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
            );
          },
        },
      },
    },
    {
      name: "orderedVia",
      label: "Ordered Via",
      options: {
        display: isBig,
      },
    },
    {
      name: "createdBy",
      label: "Created By",
      options: {
        display: isBig,
      },
    },
    {
      name: "lastEditedBy",
      label: "Last Edited By",
    },
    {
      name: "packedBy",
      label: "Packed By",
      options: {
        display: isBig,
      },
    },
    {
      name: "customerName",
      label: "Customer name",
    },
    {
      name: "orderStatus",
      label: "Status",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          display: "flex",
          justifyContent: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              label={value}
              color={
                value === "Draft"
                  ? "secondary"
                  : value === "Submited"
                    ? "primary"
                    : "success"
              }
            />
          );
        },
      },
    },
    {
      name: "paymentStatus",
      label: "Payment Status",
      options: {
        display: isBig,
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Tooltip title="Copy Order">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();

                    fetchGraphql({
                      query: `mutation Mutation($copyOrderId: ID) {
                      copyOrder(copyOrderId: $copyOrderId)
                    }`,
                      variables: { copyOrderId: tableMeta.rowData[0] },
                    }).then((result) =>
                      navigate(
                        `/orders/new-order-customer/${result.data.copyOrder}`,
                      ),
                    );
                  }}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>

              <Popover
                refExit={filterPopoverExit}
                hide={hidePopover}
                classes={{
                  closeIcon: null,
                }}
                trigger={
                  <Tooltip title="Priview Order" disableFocusListener>
                    <IconButton
                      onClick={(e) => {
                        fetchGraphql({
                          query: `query Products ($orderId: ID!) {
                          order (orderId: $orderId) {
                            customerId
                            customerName
                            deliveryDate
                            orderNote
                          }
                          orderProducts (orderId: $orderId) {
                            productId
                            productName
                            orderProductId
                            quantity
                          }
                        }`,
                          variables: { orderId: tableMeta.rowData[0] },
                        }).then((result) => {
                          setProducts(result.data.orderProducts);

                          setOrder(result.data.order);
                        });
                      }}
                    >
                      <PreviewIcon />
                    </IconButton>
                  </Tooltip>
                }
                content={
                  <Box
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                      margin: "20px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "5fr 1fr",
                        columnGap: "10px",
                      }}
                    >
                      {products?.map((item) => (
                        <>
                          <Box>{item.productName}</Box>
                          <Box>{item.quantity}</Box>
                        </>
                      ))}
                    </Box>
                  </Box>
                }
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
              />

              <Tooltip title="Print">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();

                    navigate(`/orders/order-pdf/${tableMeta.rowData[0]}`);
                  }}
                >
                  <PictureAsPdfIcon />
                </IconButton>
              </Tooltip>

              {data.find((item) => item.orderId === tableMeta.rowData[0])
                .orderNote ? (
                <Popover
                  refExit={filterPopoverExit}
                  hide={hidePopover}
                  classes={{
                    closeIcon: null,
                  }}
                  trigger={
                    <Tooltip title="Notes" disableFocusListener>
                      <IconButton
                      // onClick={(e) => {
                      //   fetchGraphql({
                      //     query: `query Products ($orderId: ID!) {
                      //     order (orderId: $orderId) {
                      //       customerId
                      //       customerName
                      //       deliveryDate
                      //       orderNote
                      //     }
                      //   }`,
                      //     variables: { orderId: tableMeta.rowData[0] },
                      //   }).then((result) => {
                      //     setProducts(result.data.orderProducts);

                      //     setOrder(result.data.order);
                      //   });
                      // }}
                      >
                        <NoteIcon color="warning" />
                      </IconButton>
                    </Tooltip>
                  }
                  content={
                    <Box
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        margin: "20px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "5fr 1fr",
                          columnGap: "10px",
                        }}
                      >
                        {
                          data.find(
                            (item) => item.orderId === tableMeta.rowData[0],
                          ).orderNote
                        }
                      </Box>
                    </Box>
                  }
                  anchorOrigin={{
                    vertical: "center",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "center",
                    horizontal: "right",
                  }}
                />
              ) : null}
            </Box>
          );
        },
      },
    },
  ];

  const handleFilterSubmit = (applyFilters) => {
    let filterList = applyFilters();

    // console.log(filterList);
    // this.setState({ isLoading: true });

    // // fake async request
    // this.xhrRequest(`/myApiServer?filters=${filterList}`, filterList).then(
    //   (res) => {
    //     this.setState({ isLoading: false, data: res.data });
    //   }
    // );
  };

  const options = {
    filterType: "multiselect",
    responsive: "scroll",
    onRowClick: (rowData) => {
      // console.log(rowData[9].props.label);
      if (
        rowData[9].props.label === "Submited" ||
        rowData[9].props.label === "Draft"
      ) {
        navigate(`new-order-customer/${rowData[0]}`);
      } else if (rowData[9].props.label === "Done") {
        navigate(`order/${rowData[0]}/order`);
      }
    },
    filter: true, // show the filter icon in the toolbar (true by default)
    serverSide: false,
    rowsPerPage: 100,
    rowsPerPageOptions: [5, 25, 50, 100],

    // makes it so filters have to be "confirmed" before being applied to the
    // table's internal filterList
    confirmFilters: true,
    selectableRows: "none",

    // customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    //   <IconButton>
    //     <Tooltip title="Print Orders">
    //       <PrintIcon />
    //     </Tooltip>
    //   </IconButton>
    // ),

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => {
              fetchGraphql({
                query: `query Orders($options: optionsInput) {
                  orders(options: $options) {
                    paymentStatus
                    packDate
                    orderedVia
                    orderStatus
                    orderId
                    orderDate
                    lastEditedBy
                    deliveryDate
                    customerName
                    customerId
                    createdBy
                  }
                }`,
                variables: {
                  options: {
                    deliveryFromDate: fromDate,
                    deliveryToDate: toDate,
                  },
                },
              }).then((result) => setData(result.data.orders));

              handleFilterSubmit(applyNewFilters);
            }}
          >
            Apply Filters
          </Button>
        </div>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      // console.log("onFilterConfirm");
      console.dir(filterList);
    },

    onFilterDialogOpen: () => {
      // console.log("filter dialog opened");
    },
    onFilterDialogClose: () => {
      // console.log("filter dialog closed");
    },
    onFilterChange: (column, filterList, type) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        // console.log("updating filters via chip");
        handleFilterSubmit(newFilters);
      }
    },
    edit: "false",
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTable: {
          styleOverrides: {
            paper: {
              maxHeight: "calc(100% - 20px)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            },
            responsiveScroll: {
              maxHeight: "100% !important",
              height: "100% ",
            },
          },
        },
      },
    });

  return (
    <MiniDrawer sx={{ margin: "150px", height: "100vh" }} key="1">
      {() => (
        <>
          <DialogSave />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "calc(100% - 40px)",
              scrollSnapType: "y mandatory",
              // overflow: "hidden"
            }}
          >
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    {messages[0] &&
                      messages.map((item) => (
                        <Box
                          sx={{
                            // minHeight: "50px",
                            backgroundColor: "#ee1a1a",
                            marginBottom: "20px",
                            flexWrap: "wrap",
                            flexGrow: 100,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "white",
                              fontSize: "28px",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {item.message}
                          </Typography>
                        </Box>
                      ))}

                    <Button
                      variant="contained"
                      sx={{ margin: "0px 0px 20px auto" }}
                      onClick={() => {
                        canView("frontDesk")
                          ? navigate(`add-customer`)
                          : fetchGraphql({
                              query: `mutation CreateOrder($order: orderInput) {
                            createOrder(order: $order)
                          }`,
                              variables: {
                                order: {
                                  customerId: null,
                                  deliveryDate: tomorowNoTime,
                                  orderedVia: canView("onlySelf")
                                    ? "Customer"
                                    : canView("frontDesk")
                                      ? "Front Desk"
                                      : "Office",
                                  orderStatus: "Draft",
                                  orderNote: null,
                                },
                              },
                            }).then((result) => {
                              navigate(
                                `new-order-customer/${result.data.createOrder}`,
                              );
                            });
                      }}
                    >
                      <AddIcon />
                      New Order
                    </Button>
                  </>
                }
              />

              <Route
                path="/*"
                element={
                  <Button
                    variant="outlined"
                    sx={{
                      margin: "0px auto 20px 0px  ",
                      scrollSnapAlign: "start",
                    }}
                    onClick={() => navigate("/orders")}
                  >
                    <ArrowBackIcon />
                    Back
                  </Button>
                }
              />
            </Routes>

            <Routes>
              <Route
                path="/"
                element={
                  <Box sx={{ height: "100%" }}>
                    <ThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={"Orders"}
                        data={data}
                        columns={columns}
                        options={options}
                      />
                    </ThemeProvider>
                  </Box>
                }
              />

              <Route path="/new-order" element={<NewOrder />} />
              <Route path="/add-customer" element={<AddCustomer />} />
              <Route
                path="/new-order-customer/:id"
                element={<NewOrderCustomer />}
              />
              <Route path="/order-pdf/:id" element={<CompleteOrder />} />
              <Route path="/order/:id/*" element={<Order />} />
            </Routes>
          </Box>
        </>
      )}
    </MiniDrawer>
  );
}
